export default __webpack_public_path__ + "static/media/progressBackground.c2f7b158.png";